import _decorate from "@babel/runtime/helpers/esm/decorate";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "@babel/runtime/helpers/esm/get";
let _ = t => t,
  _t,
  _t2,
  _t3;
function _superPropGet(t, e, r, o) { var p = _get(_getPrototypeOf(1 & o ? t.prototype : t), e, r); return 2 & o ? function (t) { return p.apply(r, t); } : p; }
/**
 * @license
 *
 * Copyright IBM Corp. 2021, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css, html } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import C4DCard from "../card/card.js";
import { CTA_TYPE } from "../cta/card-cta.js";
import "./card-in-card-image.js";
import styles from "././card-in-card.css.js";
import StableSelectorMixin from "../../globals/mixins/stable-selector.js";
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';
const {
  prefix,
  stablePrefix: c4dPrefix
} = settings;

/**
 * Card in Card.
 *
 * @element c4d-card-in-card
 * @csspart image - The Thumbnail image. Usage `c4d-card-in-card::part(image)`
 */
let C4DCardInCard = _decorate([customElement(`${c4dPrefix}-card-in-card`)], function (_initialize, _StableSelectorMixin) {
  class C4DCardInCard extends _StableSelectorMixin {
    constructor(...args) {
      super(...args);
      _initialize(this);
    }
  }
  return {
    F: C4DCardInCard,
    d: [{
      kind: "method",
      key: "_renderImage",
      value: function _renderImage() {
        const {
          ctaType,
          videoName,
          videoThumbnailUrl,
          _hasImage: hasImage
        } = this;
        const image = hasImage || ctaType !== CTA_TYPE.VIDEO ? undefined : html(_t || (_t = _`
            <c4d-card-in-card-image
              alt="${0}"
              default-src="${0}"
              part="image">
            </c4d-card-in-card-image>
          `), ifDefined(videoName), videoThumbnailUrl);
        return html(_t2 || (_t2 = _`
      <slot name="image" @slotchange="${0}"></slot>${0}
    `), this._handleSlotChange, image);
      }
    }, {
      kind: "method",
      key: "updated",
      value: function updated(changedProperties) {
        _superPropGet(C4DCardInCard, "updated", this, 3)([changedProperties]);
        const {
          _linkNode: linkNode
        } = this;
        if (linkNode) {
          linkNode.classList.add(`${prefix}--card-in-card`);
        }
        this.onclick = () => {
          var _this$querySelector;
          return (_this$querySelector = this.querySelector(`${c4dPrefix}-card-footer`)) === null || _this$querySelector === void 0 || (_this$querySelector = _this$querySelector.shadowRoot) === null || _this$querySelector === void 0 || (_this$querySelector = _this$querySelector.querySelector(`a`)) === null || _this$querySelector === void 0 ? void 0 : _this$querySelector.click();
        };
      }
    }, {
      kind: "get",
      static: true,
      key: "stableSelector",
      value: function () {
        return `${c4dPrefix}--card-in-card`;
      }
    }, {
      kind: "get",
      static: true,
      key: "styles",
      value: function () {
        return css(_t3 || (_t3 = _`
      ${0}${0}
    `), _superPropGet(C4DCardInCard, "styles", this), styles);
      }
    }]
  };
}, StableSelectorMixin(C4DCard));
/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DCardInCard;
//# sourceMappingURL=card-in-card.js.map
